module.exports = __webpack_public_path__ + "img/sketch.901a5b9f.png";